export default __webpack_public_path__ + "static/frame-2225-467b1537a4e13e1b111e3b8fd2d13b69.png";